import SubscriptionTypeSelect from '@/generated/controls/subscriptionType/SubscriptionTypeSelect.vue';
import SubscriptionType, { SubscriptionRequired } from '@/generated/classes/SubscriptionType';
import Item from '@/framework/base/classes/Item';
import { storeSubscriptionType } from '@/generated/stores';
import Subscription from '@/extend/classes/Subscription';
import { defineComponent, type PropType } from "vue";
import Ressource from '@/framework/ressource/classes/Ressource';

export default defineComponent({
  components: {},
  extends: SubscriptionTypeSelect,

  props: {
    value: {
      type: Number,
      required: true
    },
    ressource: {
      type: Object as PropType<Ressource>,
      required: true
    },
    subscription: {
      type: Object as PropType<Subscription>,
    },
    filter: {
      type: Object as PropType<SubscriptionRequired>,
    }
  },

  data () {
    return {
      minSubscriptionId: 0,
      terminateId: 0
    };
  },

  computed: {
    listItems (): Item[] {
      const res: Item[] = [];
      this.notOrdered = true;
      this.items.sort((a, b) => a.mensuel - b.mensuel).forEach((subscriptionType) => {
        if (subscriptionType && subscriptionType.canSubscribe) {
          let label = '';
          if (subscriptionType.mensuel > 0) {
            label = subscriptionType.label + ' (' + subscriptionType.mensuel + ' €/mois)';
          } else if (subscriptionType.id != this.terminateId) {
            label = subscriptionType.label + ' (gratuit)';
          } else {
            label = subscriptionType.label;
          }
          res.push(new Item(subscriptionType.id, label));
        }
      });
      return res;
    }
  },
  methods: {
    ordered (): boolean {
      return true;
    }
  }
})
